import { Switch, Redirect } from 'react-router-dom';
import MENU from 'consts/menu.consts';
import Route from 'routers/components/Route.component';
import RouterContainer from 'routers/components/RouterContainer.component';
import ActivityRealTime from 'views/activity/ActivityRealTime.view';
import VisitDetails from 'views/visit/VisitDetails.view';
import * as ObjectUtil from 'utils/object.util';

export default function AdminRouter() {
  const menu = ObjectUtil.extractLeafObjects(MENU.ADMIN).map(o => ({
    label: o.LABEL,
    redirect: o.PATH,
  }));

  return (
    <RouterContainer menu={menu}>
      <Switch>
        <Route exact container path={MENU.ADMIN.ACTIVITY['REAL-TIME'].PATH} component={ActivityRealTime} />
        <Route exact container path={MENU.ADMIN.VISIT.DETAILS.PATH} component={VisitDetails} />
        <Route path="*" component={() => <Redirect to={MENU.ADMIN.ACTIVITY['REAL-TIME'].PATH} />}/>
      </Switch>
    </RouterContainer>
  );
}
